import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kyc.css';
import moment from "moment";
import { store } from "../../redux/store";
import { setPersonalInfo, setROId, setROResponse, setSaveData } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import { setIfscCode, setSelectedBankId, setSelectedBankName } from "../../redux/misc-data/misc-data.action";

import { Link } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import Select from 'react-select'
import tokenErrorHandler from "../tokenErrorHandler";
import RegisterRetialerHeader from "../HeaderComponent/RegisterRetialerHeader";
import FooterComponet from "../FooterComponent/FooterComponet";
const httpClient = axios.create();

class AddBankDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phone: '',
            image: '',
            ifscCode: this.props.ifscCode,
            ifscCodeOnload: '',
            ifscCodeErrMsg: '',
            enteredAccNo: '',
            enteredAccNoOnLoad: '',
            enteredAccNoErrMsg: '',
            confirmedAccNo: '',
            confirmedAccNoOnLoad: '',
            confirmedAccNoErrMsg: '',
            enteredUPI: '',
            enteredUPIOnLoad: '',
            accName: '',
            accNameOnLoad: '',
            bankName: this.props.selectedBankName,
            bankNameOnLoad: '',
            bankId: this.props.selectedBankId,
            bankIdOnLoad: '',
            branch: this.props.branchAddress,
            branchOnLoad: '',

            retailerInfo: '',
            bankDetails: ''


        }
    }

    componentDidMount() {
        this.setState({
            saveDataErr: ''
        })
        this.getSessionDetails();
        this.loadAllBankDetails();
    }


    loadAllBankDetails = () => {


        // const headers = {
        // 	'Authorization': 'Bearer ' + this.props.token,
        // 	'client-id': this.props.agentInfo.id,
        // 	'role': this.props.clientRole
        // }
        var bankDetailsUrl = '/api/v1/catalog/bank/all/summary';
        httpClient.get(bankDetailsUrl,
            //  { headers }
        ).then((response) => {
            console.log('all bank details' + JSON.stringify(response.data));
            if (response.data.length > 0) {
                this.setState({
                    bankDetails: response.data
                })

            }
        }
        ).catch(error => {
            console.log('error in load bank details...' + error);
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }
        });
    }

    getSessionDetails = () => {
        httpClient.get('/api/v1/retailer/onboard/session/' + this.props.registerRetailerResponse.sessionId
            // , { headers }
        ).then((response) => {

            this.setState({
                retailerInfo: response.data
            })
            // alert('session Id retailer response' + JSON.stringify(response.data));
            if (response.data != null) {
                // alert('accountinfo...'+JSON.stringify(response.data))

                if (response.data.accountInfo != null) {

                    this.setState({
                        enteredAccNo: response.data.accountInfo.accNum,
                        // enteredAccNoOnLoad: response.data.accountInfo.accNum,
                        confirmedAccNo: response.data.accountInfo.accNum,
                        // confirmedAccNoOnLoad: response.data.accountInfo.accNum,
                        bankName: this.props.selectedBankName != '' ?
                            this.props.selectedBankName : response.data.accountInfo.bank,
                        // bankNameOnLoad: response.data.accountInfo.bank,
                        enteredUPI: response.data.accountInfo.upi,
                        // enteredUPIOnLoad: response.data.accountInfo.upi,
                        accName: response.data.accountInfo.accName,
                        // accNameOnLoad: response.data.accountInfo.accName,
                        branch: this.props.branchAddress != '' ?
                            this.props.branchAddress : response.data.accountInfo.branch,
                        // branchOnLoad: response.data.accountInfo.branch
                        ifscCode: this.props.ifscCode != '' ?
                            this.props.ifscCode : response.data.accountInfo.ifsc,
                    })
                }
            }
        }).catch(error => {

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, '/' + process.env.REACT_APP_PARTNER + '-login')
            } else {

            }
        });
    }
    componentWillUnmount() {
    }

    enterIfsc = (event) => {
        this.setState({
            ifscCode: event.target.value,
            ifscCodeErrMsg: '',
            saveDataErr: ''
        })
    }
    enterAccNo = (event) => {
        this.setState({
            enteredAccNo: event.target.value,
            enteredAccNoErrMsg: '',
            saveDataErr: ''
        })
    }
    confirmAccNo = (event) => {
        this.setState({
            confirmedAccNo: event.target.value,
            confirmedAccNoErrMsg: '',
            saveDataErr: ''
        })
    }

    enterUPI = (event) => {
        event.preventDefault();
        this.setState({
            enteredUPI: event.target.value,
            saveDataErr: ''
        })
    }

    reassignVal = () => {


        this.setState({
            saveDataErr: ''
        })

        if (this.state.enteredAccNoOnLoad != '') {
            this.setState({
                enteredAccNo: this.state.enteredAccNoOnLoad
            })
        }
        if (this.state.confirmedAccNoOnLoad != '') {
            this.setState({
                confirmedAccNo: this.state.confirmedAccNoOnLoad
            })
        }
        if (this.state.bankNameOnLoad != '') {
            this.setState({
                bankName: this.state.bankNameOnLoad
            })
        }
        if (this.state.enteredUPIOnLoad != '') {
            this.setState({
                enteredUPI: this.state.enteredUPIOnLoad
            })
        }
        if (this.state.branchOnLoad != '') {
            this.setState({
                branch: this.state.branchOnLoad
            })
        }
        if (this.state.accNameOnLoad != '') {
            this.setState({
                accName: this.state.accNameOnLoad
            })
        }
    }

    saveAndFinalizeValidation = () => {

        this.setState({
            saveDataErr: ''
        })

        //re-assigning values if exist
        // this.reassignVal();

        this.setState({
            ifscCodeErrMsg: '',
            confirmedAccNoErrMsg: ''
        })

        var ifscCodeVlidation = false;
        var accNoValidation = false;
        var accConfirmValidation = false;


        if (this.state.ifscCode != '') {
            ifscCodeVlidation = true;
        } else {
            this.setState({
                ifscCodeErrMsg: 'Please enter IFSC code'
            })
        }
        if (this.state.enteredAccNo != '') {
            accNoValidation = true;
        } else {
            this.setState({
                enteredAccNoErrMsg: 'Please enter Acc No'
            })
        }
        if (this.state.confirmedAccNo != '' &&
            (this.state.confirmedAccNo == this.state.enteredAccNo)) {
            accConfirmValidation = true;
        } else {
            this.setState({
                confirmedAccNoErrMsg: 'Acc no mismatch'
            })
        }


        if (ifscCodeVlidation == true
            && accNoValidation == true
            && accConfirmValidation == true
        ) {
            return true;
        } else {
            return false;
        }
    }

    saveBankDetails = (event) => {
        event.preventDefault();

        this.setState({
            saveDataErr: ''
        })

        if (this.saveAndFinalizeValidation() == true) {
            // alert('bank-id' + this.props.selectedBankId);
            this.setState({
                progress: 'loading'
            })

            var saveDataUrl = '/api/v1/retailer/onboard/session/save';
            var header = {
                msgType: "CREATE_ORDER",
                service: "KYC",
                src: "register-retailer",
                dst: "register-retailer",
                channel: "API",
                requesterId: 'W9853028034FPAY',
                requestId: uuidv4(),
                traceId: uuidv4(),
            }


            var accountInfo = {
                accName: null,
                bank: this.state.bankName,
                accNum: this.state.enteredAccNo,
                ifsc: this.state.ifscCode,
                bankId: this.props.selectedBankId,
                upi: this.state.enteredUPI,
                branch: this.state.branch
            }

            var request = {
                header: header,
                personalInfo: this.state.retailerInfo.personalInfo,
                shopDetails: this.state.retailerInfo.shopDetails,
                accountInfo: accountInfo,
                kycInfo: this.state.retailerInfo.kycInfo,
                sessionId: this.props.registerRetailerResponse.sessionId,
            }


            // alert('save data req:' + JSON.stringify(request));

            httpClient.post(saveDataUrl, request,
                // { headers }
            ).then((response) => {
                console.log('save data response' + JSON.stringify(response.data));
                if (response.data.response.success == true) {
                    var saveData = {
                        personalInfo: this.state.retailerInfo.personalInfo,
                        shopDetails: this.state.retailerInfo.shopDetails,
                        accountInfo: accountInfo,
                        kycInfo: this.state.retailerInfo.kycInfo,
                        sessionId: this.props.registerRetailerResponse.sessionId,
                    }

                    store.dispatch(setSaveData(saveData));

                    //call finalize
                    // this.finalize(accountInfo);

                    var gotoSetPasswordPage=document.getElementById('gotoSetPasswordPage');
                    gotoSetPasswordPage.click();

                } else {

                    this.setState({
                        progress: 'completed',
                        saveDataErr: response.data.response.displayMsg
                    })
                }
            }).catch(error => {

                this.setState({
                    progress: 'completed',
                    saveDataErr: 'Something went wrong'
                })
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else {

                }


            });
        } else {

        }

    }

    finalize = (accountInfo) => {


        this.setState({
            saveDataErr: ''
        })
        var finalizeUrl = '/api/v1/retailer/onboard/session/finalize';
        var header = {
            msgType: "CREATE_ORDER",
            service: "KYC",
            src: "register-retailer",
            dst: "register-retailer",
            channel: "API",
            requesterId: 'W9853028034FPAY',
            requestId: uuidv4(),
            traceId: uuidv4(),
        }
        var request = {
            header: header,
            password: '123456',
            sessionId: this.props.registerRetailerResponse.sessionId,
        }
        // const headers = {
        //     'Authorization': 'Bearer ' + this.props.token,
        //     'client-id': this.props.agentInfo.id,
        //     'role': this.props.clientRole
        // }
        httpClient.post(finalizeUrl, request,
            // { headers }
        ).then((response) => {
            console.log('finalize response' + JSON.stringify(response.data));
            if (response.data.response.success == true) {
                store.dispatch(setROResponse(response.data));
                store.dispatch(setROId(response.data.retailerId));

                var gotoKycDetailsBtn = document.getElementById('gotoKycDetailsBtn');
                gotoKycDetailsBtn.click();
                // this.assignAgentToRoId(response.data.retailerId);
            } else {

                this.setState({
                    progress: 'completed',
                    saveDataErr: response.data.response.displayMsg
                })
                //temp

                // store.dispatch(setROResponse(response.data));
                // store.dispatch(setROId(response.data.retailerId));
                // this.assignAgentToRoId(response.data.retailerId);
            }
        }).catch(error => {

            this.setState({
                progress: 'completed',
                saveDataErr: 'Something went wrong'
            })
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }
 

        });
    }
    backToUploadId = () => {
        var backToUploadIdBtn = document.getElementById('backToUploadIdBtn');
        backToUploadIdBtn.click();
    }

    bankChange = (selected) => {

        this.setState({
            saveDataErr: ''
        })

        store.dispatch(setSelectedBankName(selected.value));
        store.dispatch(setIfscCode(''));
        this.setState({
            selectedBankName: selected.value,
            ifscCode: ''
        })
        this.state.bankDetails.map(banks => {
            if (banks.name == selected.value) {
                if (banks.masterIfsc != null && banks.masterIfsc != '') {
                    this.setState({
                        ifscCode: banks.masterIfsc
                    })
                }
                this.setState({
                    selectedBankName: banks.name,
                    bankId: banks.id,
                })
                store.dispatch(setIfscCode(banks.masterIfsc != null ? banks.masterIfsc.toUpperCase() : ''));
                store.dispatch(setSelectedBankId(banks.id));

                // alert('bank id...' + banks.id);

            }
        })
    }

    assignAgentToRoId = (retailerId) => {
        this.setState({
            kycProcessErr: ''
        })
        // const headers = {
        //     'Authorization': 'Bearer ' + this.props.token,
        //     'client-id': this.props.agentInfo.id
        // };

        httpClient.post('/api/v1/finxpay/user/' + retailerId + '/assign/' + retailerId + '/SYS_REGISTERED'
            , '',
            // { headers }
        ).then((response) => {
            console.log('assign Agent to Ro id response' + JSON.stringify(response.data));
            if (response.data.response.success == true) {
                store.dispatch(setROId(response.data.retailerId));

                this.setState({
                    progress: 'completed'
                })

                var gotoKycDetailsBtn = document.getElementById('gotoKycDetailsBtn');
                gotoKycDetailsBtn.click();
            } else {
                this.setState({
                    progress: 'completed',
                    saveDataErr: response.data.response.displayMsg
                })

                //temp
                this.setState({
                    progress: 'completed'
                })

                // var gotoKycDetailsBtn = document.getElementById('gotoKycDetailsBtn');
                // gotoKycDetailsBtn.click();

            }
        }).catch(error => {
            this.setState({
                progress: 'completed',
                saveDataErr: 'Something went wrong'
            })
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }
 

        });
    }


    backToAddressDetail = () => {
        var backToAddressDetailBtn = document.getElementById('backToAddressDetailBtn');
        backToAddressDetailBtn.click();
    }

    render() {



        var searchableBankList = [];
        if (this.state.bankDetails != '' &&
            this.state.bankDetails != null &&
            this.state.bankDetails != undefined) {
            this.state.bankDetails.map(bank => {
                var stateVal = {
                    value: '',
                    label: ''
                }
                stateVal.value = bank.name;
                stateVal.label = bank.name;
                searchableBankList.push(stateVal);
            })
        }

        return (
            <div>
                <RegisterRetialerHeader />
                {/* <Menu /> */}
                <div class="mid-contant1">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="main-heading">
                                    <h2>Bank Details</h2>
                                </div>
                                {/* <Link to='/kyc-details'>
                                    <button id='gotoKycDetailsBtn' hidden={true}></button>
                                </Link> */}
                                <Link to='/kyc-details'>
                                    <button id='gotoKycDetailsBtn' hidden={true}></button>
                                </Link>
                                <Link to='/set-password'>
                                    <button id='gotoSetPasswordPage' hidden={true}></button>
                                </Link>
                            </div>

                            <div class="col-12">
                                <div class="registerbox">
                                    <div class="row mb-3">
                                        <div class="col-12 col-lg-7">
                                            <form onSubmit={this.saveBankDetails}>
                                                <div class="row">
                                                    {

                                                        (this.state.bankName != '') ?
                                                            <div class="col-12 col-sm-6">
                                                                <label for="bank">Bank Name</label>
                                                                <div class="form-floating">

                                                                    <div class="form-floating">
                                                                        <Select options={searchableBankList} class="form-control"
                                                                            SelectContainer={true}
                                                                            defaultValue={{ label: this.state.bankName, value: this.state.bankName }}
                                                                            onChange={this.bankChange}
                                                                            placeholder={"Selecet Bank..."}
                                                                        />

                                                                    </div>



                                                                </div>
                                                            </div>
                                                            :
                                                            <div class="col-12 col-sm-6">


                                                                <label for="bank">Bank Name</label>
                                                                <div class="form-floating">
                                                                    <Select options={searchableBankList} class="form-control"
                                                                        onChange={this.bankChange}
                                                                        placeholder={"Selecet Bank..."}
                                                                        />

                                                                </div>
                                                            </div>
                                                    }

                                                    <br />
                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="ifsc" placeholder="Enter IFSC" value={this.state.ifscCode}
                                                                onChange={this.enterIfsc} />
                                                            <label for="ifsc">Enter IFSC code</label>
                                                            <a href="/retailer-ifsc" class="searchifsc">search ifsc</a>
                                                        </div>
                                                        {this.state.ifscCodeErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.ifscCodeErrMsg}
                                                            </div>}
                                                    </div>



                                                    {(this.state.branch != '' &&
                                                        this.state.branch != null) ?
                                                        <div class="col-12">
                                                            <div class="bankname">{this.state.branch.toUpperCase()}</div>
                                                        </div> :
                                                        <div class="col-12">
                                                            {/* <div class="bankname">{this.state.branch.toUpperCase()}</div> */}
                                                        </div>

                                                    }

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="account1" placeholder="Enter Account" value={this.state.enteredAccNo}
                                                                onChange={this.enterAccNo} />
                                                            <label for="account1">Enter account number</label>
                                                        </div>
                                                        {this.state.enteredAccNoErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.enteredAccNoErrMsg}
                                                            </div>}
                                                    </div>

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="add2" placeholder="Enter Address" value={this.state.confirmedAccNo}
                                                                onChange={this.confirmAccNo} />
                                                            <label for="add2">Confirm account number</label>
                                                        </div>
                                                        {this.state.confirmedAccNoErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.confirmedAccNoErrMsg}
                                                            </div>}
                                                    </div>

                                                    {/* <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="upi" placeholder="Enter UPI" value={this.state.enteredUPI}
                                                                onChange={this.enterUPI} />
                                                            <label for="upi">Enter UPI ID</label>

                                                            
                                                        </div>
                                                    </div> */}

                                                    <div class="col-12">
                                                        <button type="submit" class="btn btn-primary" id="">Submit</button>
                                                        {this.state.saveDataErr != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.saveDataErr}</div>}
                                                    </div>

                                                </div>
                                            </form>
                                        </div>

                                        <div class="col-12 col-lg-5 d-none d-lg-block">
                                            <div class="topbtn">
                                                <a onClick={this.backToAddressDetail}>Back</a>
                                            </div>
                                            <Link to='/add-business-details'>
                                                <button id='backToAddressDetailBtn' hidden={true}></button>
                                            </Link>
                                            <div class="rightbanner"><img src="images/bank-img.png" alt="" class="img-fluid" /></div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponet />

            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, agentInfo, token, clientRole, deviceInfo, clientRequesterId, callBackUrl, ifscCode, selectedBankName,
            selectedBankId, bankDetails,
            branchAddress },
        retailerKycReduce: { registerRetailerResponse, personalInfo, saveDataVal,

        } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, agentInfo,
    token, clientRole, deviceInfo, clientRequesterId, callBackUrl, ifscCode, selectedBankName,
    selectedBankId, bankDetails,
    branchAddress,
    registerRetailerResponse, personalInfo, saveDataVal,

});

export default connect(mapStateToProps, null)(AddBankDetails);
